import React from 'react'
import { Divider } from '@material-ui/core'
import { FormattedMessage } from 'react-intl'
import Button from '@material-ui/core/Button'
import { makeStyles } from '@material-ui/styles'
import clsx from 'clsx'

const useStyles = makeStyles((theme) => ({
  sectionDivider: {
    backgroundColor: theme.palette.notificationPreview.sectionDivider,
  },
  actionButton: {
    color: theme.palette.secondary.main,
    borderColor: theme.palette.secondary.main,
    '&:hover': {
      backgroundColor: 'transparent',
    },
  },
}))

const NotificationEventAction = ({ readonly = false }) => {
  const classes = useStyles()
  return (
    <div className="mt-8">
      <Divider className={classes.sectionDivider} />
      <div className="flex py-16 px-12 min-w-xs">
        {readonly ? (
          <div
            className={clsx(
              classes.actionButton,
              'w-1/3 my-0 ltr:mr-5 rtl:ml-5 p-2 text-xs cursor-default',
              'border-1 rounded-4 flex justify-center items-center font-bold',
            )}
          >
            <FormattedMessage id="notificationTimeline.preview.event.action.going" />
          </div>
        ) : (
          <Button
            variant="outlined"
            className={clsx(
              classes.actionButton,
              'w-1/3 my-0 ltr:mr-5 rtl:ml-5 p-2 text-xs cursor-default',
            )}
          >
            <FormattedMessage id="notificationTimeline.preview.event.action.going" />
          </Button>
        )}
        {readonly ? (
          <div
            className={clsx(
              classes.actionButton,
              'w-1/3 my-0 ltr:mr-5 rtl:ml-5 p-2 text-xs cursor-default',
              'border-1 rounded-4 flex justify-center items-center font-bold',
            )}
          >
            <FormattedMessage id="notificationTimeline.preview.event.action.maybe" />
          </div>
        ) : (
          <Button
            variant="outlined"
            className={clsx(
              classes.actionButton,
              'w-1/3 my-0 ltr:mr-5 rtl:ml-5 p-2 text-xs cursor-default',
            )}
          >
            <FormattedMessage id="notificationTimeline.preview.event.action.maybe" />
          </Button>
        )}

        {readonly ? (
          <div
            className={clsx(
              classes.actionButton,
              'w-1/3 my-0 ltr:mr-5 rtl:ml-5 p-2 text-xs cursor-default',
              'border-1 rounded-4 flex justify-center items-center font-bold',
            )}
          >
            <FormattedMessage id="notificationTimeline.preview.event.action.notGoing" />
          </div>
        ) : (
          <Button
            variant="outlined"
            className={clsx(
              classes.actionButton,
              'w-1/3 my-0 ltr:mr-5 rtl:ml-5 p-2 text-xs cursor-default',
            )}
          >
            <FormattedMessage id="notificationTimeline.preview.event.action.notGoing" />
          </Button>
        )}
      </div>
      <Divider className={classes.sectionDivider} />
    </div>
  )
}

export default NotificationEventAction
